import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  columns,
  formFields,
  otherFields,
  initObject,
  filterFields,
  filterInitialValues,
  ObjectEditSchema,
  seatColumns,
  newprepareFilter,
  newfilterFields,
  newfilterInitialValues,
  rowFormatter,
  editRowFormatter
} from './AuditFormResultUtils';
import { AuditFormListEditPage } from './AuditFormListEditPage';


const SeatAuditFormResultPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.seatAuditFormList }),
    shallowEqual
  );

  const { resultState } = useSelector(
    (state) => ({ resultState: state.seatAuditFormResults }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url === "/resultForms")) {
    const temp = menuList.find(q => q.url === "/resultForms")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute
            path="/resultForms/seats/:id/edit"
            render={props =>
              <AuditFormListEditPage
                {...props}
                isFullAccess={isFullAccess}
                basePath="/resultForms/seats"
                api="api/AuditFormResult"
                methodName="GetSeatsResultByFormListId"
                updateMethodName="UpdateSeatResultStatus"
                exportfuncName="GetExportSeatsResultByFormListId"
                currentState={resultState}
                listState={currentState}
                initObject={initObject}
                columns={columns}
                formFields={formFields}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                prepareFilter={newprepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                // otherTabs={otherTabs}
                rowFormatter={editRowFormatter}
                isSeatForm={true}
              />
            }
          />

          <ContentRoute
            path="/resultForms/seats"
            render={props =>
              <ObjectsPage
                getFunctionName="GetSeats"
                filterByShowButton={false}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/resultForms/seats"
                api="api/AuditFormList"
                currentState={currentState}
                columns={seatColumns}
                prepareFilter={newprepareFilter}
                filterFields={newfilterFields}
                filterInitialValues={newfilterInitialValues}
                // hideSelected={true}
                checkActive={true}
                rowFormatter={rowFormatter}
                showAuditResultForm={true}
              />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default SeatAuditFormResultPage



